<div class="jobs-wrapper">

  <div class="photo-header text-center flex items-center" style="background-image: url(../assets/img/contact/contact-hero-bg.jpg)">

    <div class="mx-auto">

      <h1 class="uppercase text-white font-display font-normal photo-header__headline">
        Contact Us
      </h1>

    </div>

  </div>
  <!--/photo-header-->

  <div class="contact-main-wrapper">

    <div class="contact-main mx-auto container container-padding md:flex">

      <div class="md:w-3/5 py-10 md:py-16 md:pr-10 xxl:pr-20">

        <h2 tabindex="0" class="text-3xl md:text-30px"><strong>Want to get in touch?</strong></h2>

        <p>Looking for a price quote, more product information, or just want to say hi?<br> Give us a call, shoot us an email, or use the contact form below! </p>


        <form [formGroup]="contactUsForm" class="mt-8">
          <label for="questions" class="text-sm">
            <strong>Why are you contacting us today?</strong>
            <div class="input-required-message" style="margin-left: 0;" aria-label="All fields are mandatory">All fields are mandatory*</div>
          </label>
          <div class="mb-3 mt-3 input-group">
            <select id="questions" aria-describedby="choose-one-required-errors" autocomplete="choose-one" required [(ngModel)]='selectedValue' [ngClass]="{'input--error': contactUsForm.controls.contactReason.invalid && contactUsForm.controls.contactReason.touched}" type="text" formControlName="contactReason" class="input w-full" placeholder="Choose One">
              <option value='' selected [disabled]="selectedValue == ''">Choose One</option>
              @for (option of contactUsArray?.contactReasons; track option) {
                <option>{{option.contactReasonText}}</option>
              }
            </select>
            @if (contactUsForm.controls.contactReason.errors) {
              <div id="choose-one-required-errors">
                <!-- <div class="input-error-message">This email address already exists</div> -->
                @if (contactUsForm.controls.contactReason.errors.required && contactUsForm.controls.contactReason.touched) {
                  <div class="input-error-message">
                    Contact reason is required.
                  </div>
                }
              </div>
            }
          </div>

          <div class="md:flex">
            <div class="mb-3 input-group md:w-full md:mr-2">
              <input id="questions-name-input" aria-describedby="name-required-errors" autocomplete="name" [ngClass]="{'input--error': contactUsForm.controls.name.invalid && contactUsForm.controls.name.touched}" type="text" class="input w-full" placeholder="Name" formControlName="name">
              <label for="questions-name-input" class="input-faux-label">Name</label>
              @if (contactUsForm.controls.name.errors) {
                <div id="name-required-errors">
                  @if (contactUsForm.controls.name.errors.required && contactUsForm.controls.name.touched) {
                    <div class="input-error-message">
                      Name is required.
                    </div>
                  }
                </div>
              }
            </div>

            <div class="mb-6 input-group md:w-full md:ml-2">
              <input type="text" id="questions-email-input" aria-describedby="email-required-errors" class="input w-full" placeholder="Email" autocomplete="email" id="txtEmailId" [ngClass]="{'input--error': contactUsForm.controls.emailAddress.invalid && contactUsForm.controls.emailAddress.touched}" formControlName="emailAddress">
              <label class="input-faux-label" for="questions-email-input">Email</label>
              @if (contactUsForm.controls.emailAddress.errors) {
                <div id="email-required-errors">
                  <!-- <div class="input-error-message">This email address already exists</div> -->
                  @if (contactUsForm.controls.emailAddress.errors.required && contactUsForm.controls.emailAddress.touched) {
                    <div class="input-error-message">
                      Email is required.
                    </div>
                  }
                  @if ((contactUsForm.controls.emailAddress.errors.pattern && contactUsForm.controls.emailAddress.touched) || contactUsForm.controls.emailAddress.errors.email) {
                    <div class="input-error-message">
                    Please enter valid email.</div>
                  }
                </div>
              }
            </div>

          </div>

          <div class="mb-3 input-group">
            <input id="questions-subject-input" aria-describedby="subject-required-errors" autocomplete="subject" formControlName="subject" [ngClass]="{'input--error': contactUsForm.controls.subject.invalid && contactUsForm.controls.subject.touched}" type="text" class="input w-full" placeholder="Subject">
            <label for="questions-subject-input" class="input-faux-label">Subject</label>
            @if (contactUsForm.controls.subject.errors) {
              <div id="subject-required-errors">
                @if (contactUsForm.controls.subject.errors.required && contactUsForm.controls.subject.touched) {
                  <div class="input-error-message">
                    Subject is required.
                  </div>
                }
              </div>
            }
          </div>

          <div class="mb-3 input-group">
            <textarea id="questions-question-input" aria-describedby="question-required-errors" autocomplete="question" formControlName="message" [ngClass]="{'input--error': contactUsForm.controls.message.invalid && contactUsForm.controls.message.touched}" class="input w-full" placeholder="Question" rows="5"></textarea>
            <label for="questions-question-input" class="input-faux-label">Question</label>
            @if (contactUsForm.controls.message.errors) {
              <div id="question-required-errors">
                @if (contactUsForm.controls.message.errors.required && contactUsForm.controls.message.touched) {
                  <div class="input-error-message">
                    Question is required.
                  </div>
                }
              </div>
            }
          </div>

          <div class="mt-10">
            <button class="button button--border block mb-3 md:inline-block" (click)="submitContactForm()" [disabled]="!contactUsForm.valid">Submit</button>
          </div>
        </form>
      </div>

      <div class="py-10 px-5 -mx-5 mt-12 bg-grey-lighter md:mx-auto md:w-2/5 md:py-16 md:px-10">

        <div class="mb-8">
          <h2 tabindex="0" class="opacity-50 uppercase font-semibold text-13px">PHONE</h2>
          800.497.0010<br> 401.253.3840
          <br> 8am - 5pm Monday through Friday
          </div>
          <!--
          <div class="mb-8">
            <a href="https://www.google.com/maps/place/Jamestown+Distributors/@41.700454,-71.2750667,17z/data=!3m1!4b1!4m5!3m4!1s0x89e456a783eec443:0xcc49b3bbb5acdbbd!8m2!3d41.70045!4d-71.272878" target="_blank" class="text-black no-underline">
              <div class="opacity-50 uppercase font-semibold text-13px">BRISTOL STORE</div>
              17 Peckham Drive<br> Bristol, RI 02809<br> 7:30am - 6pm Monday through Friday
            </a>
          </div>
          -->
          <!-- <div class="mb-8">
          <div class="opacity-50 uppercase font-semibold text-13px">WHOLESALE OR INTERNATIONAL ACCOUNTS</div>
          Visit our <a href="#" class="no-underline"><strong>JD Pro Page</strong></a>
        </div> -->

        <div class="mb-8">
          <h2 tabindex="0" class="opacity-50 uppercase font-semibold text-13px">SOCIAL</h2>
          <ul class="flex flex-wrap list-style-none pl-0">
            <li>
              <a target="_blank" href="https://www.facebook.com/JamestownDistributors/" aria-label="Facebook - jamestown Distributors - 1 of 4" class="text-2xl mr-3"><i
              class="fab fa-facebook-f"></i></a>
            </li>
            <li>
              <a target="_blank" href="https://www.youtube.com/user/JamestownTV" aria-label="youtube - jamestown Distributors - 2 of 4" class="text-2xl mr-3"><i
              class="fab fa-youtube"></i></a>
            </li>
            <li>
              <a target="_blank" href="https://www.instagram.com/totalboat/" aria-label="instagram - jamestown Distributors - 3 of 4" class="text-2xl mr-3"><i
              class="fab fa-instagram"></i></a>
            </li>
            <li>
              <a target="_blank" href="https://twitter.com/JDTotalBoat" aria-label="twitter - jamestown Distributors - 4 of 4" class="text-2xl mr-3"><i
              class="fab fa-twitter"></i></a>
            </li>
          </ul>
        </div>

      </div>

    </div>

  </div>
  <!--
  <div class="callout-section callout-section--full-width">

    <div class="mx-auto container container-padding pt-12 pb-20 md:flex items-center lg:py-32">

      <div class="md:w-1/2 md:pr-4 lg:pr-8">
        <div class="mb-4 callout-section__image" style="background-image: url(../assets/img/contact/contact-image.jpg);"></div>
      </div>

      <div class="md:w-1/2 md:pl-4 lg:pl-8 md:flex items-center">
        <div>
          <div class="uppercase text-30px font-display lines-left-red mb-4 md:mb-0">Our Bristol Store</div>

          <p>We've expanded our store to nearly 7,000 square feet of boating essentials. Shop our large selection of marine paint, varnish, and epoxy all the way to PFDs and Mercury outboards. Backed by two fully stocked warehouses, we've got you
          covered.</p>

          <a href="https://www.google.com/maps?hl=en&q=17+Peckham+Drive+Bristol,+RI+02809" target="_blank" class="inline-block mt-1 button button--border w-full md:w-auto">Get Directions</a>

        </div>
      </div>

    </div>

  </div>
  -->
  <!--/callout-section-->

  <support-footer></support-footer>

</div>
<!--/home-wrapper-->
